export const DESKTOP_STYLES = {
  maxWidth: '1280px',
  containerPosition: 'relative',
  containerHeight: '100vh',
  maxListHeight: '650px',
  scrollbarWidth: 'none'
};

export default { DESKTOP_STYLES };
